export default function StatsCards() {
  return (
    <div className="stats-grid">
      <div className="card">
        <p>Actual Value</p>
        <h2>€ 104.350</h2>
      </div>

      <div className="card">
        <p>Actual Return</p>
        <h2>€ + 4.350</h2>
      </div>

      <div className="card positive">
        <p>Percentage Return</p>
        <h2 class="positive">+2,90%</h2>
      </div>
    </div>
  );
}